export default {
  // Set Filter
  selectAll: "Вибрати все",
  selectAllSearchResults: "Вибрати все результати пошуку",
  searchOoo: "Пошук ...",
  blanks: "Заготівля",
  noMatches: "Ні збігів.",

  // Number Filter & Text Filter
  filterOoo: "Фільтр ...",
  equals: "Так само",
  notEqual: "Не одно",

  // Number Filter
  lessThan: "Менше ніж",
  greaterThan: "Більше ніж",
  lessThanOrEqual: "Менше або дорівнює",
  greaterThanOrEqual: "Більше або дорівнює",
  inRange: "У діапазоні",
  inRangeStart: "Кому",
  inRangeEnd: "Від",

  // Text Filter
  contains: "Містить",
  notContains: "Не містить",
  startsWith: "Починається з",
  endsWith: "Закінчується на",

  // Date Filter
  dateFormatOoo: "Yyyy-mm-dd",

  // Filter Conditions
  andCondition: "І",
  orCondition: "АБО",

  // Filter Buttons
  applyFilter: "Застосувати фільтр",
  resetFilter: "Скинути фільтр",
  clearFilter: "Очистити фільтр",
  cancelFilter: "Скасувати фільтр",

  // Side Bar
  columns: "Колонки",
  filters: "Фільтри",

  // columns tool panel
  pivotMode: "Опорний режим",
  groups: "Групіровка рядків",
  rowGroupColumnsEmptyMessage: "Перетягніть сюди, щоб встановити групи рядків",
  values: "Значення",
  valueColumnsEmptyMessage: "Перетягніть сюди для агрегування",
  pivots: "Мітки стовпців",
  pivotColumnsEmptyMessage: "Перетягніть сюди, щоб встановити мітки стовпців",

  // Header of the Default Group Column
  group: "Група",

  // Other
  loadingOoo: "Завантаження ...",
  noRowsToShow: "Інформація відсутня",
  enabled: "Включено",

  // Menu
  pinColumn: "Закріпити колонку",
  pinLeft: "Закріпити зліва",
  pinRight: "Закріпити справа",
  noPin: "Не закріплено",
  valueAggregation: "Агрегація значень",
  autosizeThiscolumn: "Авторазмер цього стовпця",
  autosizeAllColumns: "Авторазмер всіх стовпців",
  groupBy: "Групувати за",
  ungroupBy: "Розгрупувати по",
  resetColumns: "Скидання стовпців",
  expandAll: "Розгорнути все",
  collapseAll: "Звернути усі",
  copy: "Копіювати",
  ctrlC: "Ctrl + C",
  copyWithHeaders: "Копіювати з заголовками",
  paste: "Вставити",
  ctrlV: "Ctrl + V",
  export: "Експорт",
  csvExport: "Експорт CSV",
  excelExport: "Експорт Excel (.xlsx)",
  excelXmlExport: "Експорт Excel (.xml)"
};
